import React, { Component } from "react"
import HelpForm from "../../components/HelpForm"
import { Helmet } from "react-helmet"
import { DEFAULT_LOGO } from "../../shared/constants"
import { MetaData, structuredPageData } from "../../shared/structureData"

import "./help.scss"

class Help extends Component {
  renderSEO = () => {
    //RT: TODO down the road this should come from the DB.
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/help"
    ;(seo.title = `Help | ETR`),
      (seo.image = DEFAULT_LOGO),
      (seo.description =
        "Get help with your ETR account, access to new research, a ETR Insights event - or browse through frequently asked questions.")

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  render() {
    return (
      <div className="help-page-container">
        {this.renderSEO()}
        <div className="help-title-container">
          <span>
            Access the insights, schedule a demo with our team today. Stay in
            touch.
          </span>
        </div>

        <HelpForm {...this.props} />
      </div>
    )
  }
}

export default Help
